import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import {Collapse, Label, Button, Input, Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
//import Select from 'react-select';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom';
import jwt_decode from "jwt-decode";
import Select from 'react-select';
import moment from 'moment';
import CommonNavbar, {navbar} from "./commonNavbar";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class AdminPromotionMaster extends Component {
    constructor(props){
        super(props);
        this.state = {
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            unmappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            deleteKeys:[],
            user_id: null,
            map_status: null,
            stored_file_name: null,
            file_name: null,
            userGroup: null,
            id: null,
            campaign_response: [],
            emiMenus:[],
            party_master_id: null,
            party_options: [
                { value: 'Brand', label: 'Brand' },
                { value: 'Merchant', label: 'Merchant' },
            ],
            party_list: [],
            selected_party_type: null,
            selected_party: null,
            selected_party_type2: null,
            selected_party2: null,
            upload_user_type: null,
            partyTypeID: '',
            partyTypeValue: null,
            partyID: '',
            partyValue: null,
            files_data: null,
            bank_files: [],
            brand_files: null,
            innoviti_files: null,
            merchant_files: [],
            campaignConfirmationModel: false,
            promotion_id: null,
            selectedFile1: null,
            selectedFile2:null,
            selectedFile3:null,
            selectedFile4:null,
            bank_count: 0,
            merchant_count: 0,
            merchant_files_out: [],
            bank_files_out: [],
            new_it: 0,
            new_to: 0,
            upload_disabler: false
        };
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        this._refreshCampaign();
        //this.getPartyID();
        this.getPartyList();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }

    // getPartyID(){
    //     if ($.fn.DataTable.isDataTable('#party_showTable')) {
    //         $('#party_showTable').DataTable().destroy();
    //     }
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     console.log(decoded.userGroup);
        
    //     axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //         params: {
    //             user_id: decoded._id,
    //         }
    //     }).then(response => {
    //         if(response.data.length == 0 && (decoded.userGroup == 1 || decoded.userGroup == '1')){
    //             this.setState({
    //                 party_master_id: 3,
    //                 loading: false,
    //                 user_id: decoded._id
    //             }, () => {
    //                 //this._refreshCampaign();
    //             });
                 
    //         }
    //         else{
    //             response.data.map((values, index) => {
    //                 console.log(values.party_id);
    //                 this.setState({
    //                     party_master_id: values.party_id,
    //                     loading: false,
    //                     user_id: decoded._id,
    //                     selected_party: this.state.party_master_id,
    //                     party_id_mapper: response.data
    //                 }, () =>{
    //                     this._refreshCampaign();
    //                 })
    //             })
    //             $('#party_showTable').DataTable();
    //         }
    //         //console.log(response.data);
    //     });
        
    // }

    setDescription = (optionSelected) => {
        this.setState({ selectedDescription: optionSelected });
        //console.log(this.state.selectedDescription)
    };
    updateSKU = (optionSelected) => {
        this.setState({ selectedSKU: optionSelected.value })
    };
    updatePrice = (optionSelected) => {
        this.setState({ selectedPrice: optionSelected.value })
    };

    openActivateConfirmation = (status) => {
        this.setState({
            mapFieldCampaign: status,
            campaignConfirmationModel: !this.state.campaignConfirmationModel
        });
    }

    toggleCampaignModel() { 
        this.setState({
            campaignConfirmationModel: !this.state.campaignConfirmationModel
        });
    }

    checkMimeType=(event)=>{
        //getting file object
        var files = event.target.files 
        //define message container
        var err = ''
        // list allow mime type
       const types = ['image/png', 'image/jpeg', 'text/plain', 'application/zip', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/pdf', 'message/rfc822']
        // loop access array
        for(var x = 0; x<files.length; x++) {
                //console.log(files[x]);
             if (types.every(type => files[x].type !== type)) {
             // create error message and assign to container   
             err += files[x].type+' is not a supported format\n';
           }
         };
      
       if (err !== '') { // if message not same old that mean has error 
            event.target.value = null // discard selected file
            //console.log(err)
            this.handleNotificationClick("tr", 3, "Upload only valid file formats");
            return false; 
        }
       return true;
      
      }

    onChangeHandler1=event=>{
        //console.log(event.target.name)
        var files = event.target.files[0]
        var files1 = event.target.files;
        if(files1.length == 0){
            this.setState({
                selectedFile1: null
            })
        }
        else{
            if(this.checkMimeType(event)){ 
            // if return true allow to setState
                this.setState({
                    selectedFile1: files,
                    upload_it: true
                })
            }
            else{
                this.setState({
                    selectedFile1: null,
                    upload_it: false
                })
            }
        }
    }

    onChangeHandler2=event=>{
        var files = event.target.files[0]
        var files1 = event.target.files;
        if(files1.length == 0){
            this.setState({
                selectedFile2: null
            })
        }
        else{
            if(this.checkMimeType(event)){ 
                // if return true allow to setState
                this.setState({
                    selectedFile2: files,
                    upload_it: true
                })
            }
            else{
                this.setState({
                    selectedFile2: null,
                    upload_it: false
                })
            }
        }
    }

    onChangeHandler3=(index, event)=>{
        var files = event.target.files
        if(files.length == 0){
            this.setState({
                selectedFile3: {...this.state.selectedFile3, [index]:null }
            })
        }
        else{
            if(this.checkMimeType(event)){ 
                // if return true allow to setState
                this.setState({
                    selectedFile3: {...this.state.selectedFile3, [index]:files },
                    upload_it: true
                })
            }
            else{
                this.setState({
                    selectedFile3: {...this.state.selectedFile3, [index]:null },
                    upload_it: false
                })
            }
        }
    }

    onChangeHandler4=(index, event)=>{
        var files = event.target.files;
        //console.log(files.length);
        if(files.length == 0){
            this.setState({
                selectedFile4: {...this.state.selectedFile4, [index]:null }
            })
        }
        else{
            if(this.checkMimeType(event)){ 
                // if return true allow to setState
                    this.setState({
                        selectedFile4: {...this.state.selectedFile4, [index]:files },
                        upload_it: true
                    })
                }
                else{
                    this.setState({
                        selectedFile4: {...this.state.selectedFile4, [index]:null },
                        upload_it: false
                    })
            }
        }
    }

    
    
    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }

    // campaignDropdown = () => {
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     if (this.state.partyValue != null){
    //         if(this.state.partyValue.length > 1){
    //             this.handleNotificationClick("tr", 3, "Select only one party");
    //         }
    //         else if(this.state.partyValue.length == 1){
    //             var checker = this.state.partyValue;
    //             if (checker[0].value1 == 'Merchant'){
    //                 this.handleNotificationClick("tr", 3, "Promotion creation for merchant currently unavailable");
    //             }
    //             else{
    //                 this.state.partyValue.map((valuer, index) => {
    //                     this.setState({
    //                         party_master_id: valuer.value,
    //                         upload_user_type: 7,
    //                         uploadDropdown: true
    //                     }, () =>{
    //                         this.props.history.push('/admin/admin-create-promotion/' + this.state.party_master_id);
    //                     })
    //                 })
    //             }
    //         }
    //     }
    //     else{
    //         this.handleNotificationClick("tr", 3, "Select atleast one party");
    //     }  
    // }
    
    campaignDropdown = () => {
        this.props.history.push('/admin/admin-create-promotion1');
    }


    _refreshCampaign() {
        if ($.fn.DataTable.isDataTable('#campaignTable')) {
            $('#campaignTable').DataTable().destroy();
        }

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(decoded.userGroup == 1 && decoded.userSubGroup == 10){
            axios.post(config.get('API_URL') + '/brandemi/get_promotion_master_filter_configure', {
                party_type: this.state.partyTypeID,
                party_id: this.state.partyID
            }, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                //console.log(response);
                // Sort the data by record_update_timestamp in descending order
                console.log("Before sorting:", response.data.data.map(item => item.record_update_timestamp));
               let sortedData = response.data.data.sort((a, b) => {
                return new Date(b.record_update_timestamp) - new Date(a.record_update_timestamp);
               });
                this.setState({
                    campaign_response: response.data.data
                });
                $('#campaignTable').DataTable({
                    "oLanguage": {
                        "sEmptyTable": "No approved promotions present"
                    }
                });
                this.setState({
                    loading: false
                })
    
            });
        }
        else{
            axios.post(config.get('API_URL') + '/brandemi/get_promotion_master_filter', {
                party_type: this.state.partyTypeID,
                party_id: this.state.partyID
            }, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                //console.log(response);
                // Sort the data by record_update_timestamp in descending order
                console.log("Before sorting:", response.data.data.map(item => item.record_update_timestamp));
                let sortedData = response.data.data.sort((a, b) => {
                return new Date(b.record_update_timestamp) - new Date(a.record_update_timestamp);
               });
                this.setState({
                    campaign_response: response.data.data
                });
                $('#campaignTable').DataTable({
                    "oLanguage": {
                        "sEmptyTable": "You have not created any promotions"
                    }
                });
                
                this.setState({
                    loading: false
                })
    
            });
        }
    }

    // uploadFilesData(promotion_id){
    //     this.setState({
    //         isSubmit: true,
    //         loading: true,

    //     });
        
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     // console.log(decoded);
    //     const data1 = new FormData();
    //     data1.append('promotion_id', promotion_id);
    //     //console.log(data1);
    //     axios.post(config.get('API_URL') + "/brandemi/promotion_subvention_return", data1,{
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         }
    //     })
    //         .then(res => {
    //             //console.log(res.data.bank);
    //             //console.log(res.data.merchant);
    //             this.setState({
    //                 files_data: res.data,
    //                 bank_files: res.data.bank,
    //                 bank_count: res.data.bank.length,
    //                 brand_files: res.data.brand,
    //                 innoviti_files: res.data.innoviti,
    //                 merchant_files: res.data.merchant,
    //                 merchant_count: res.data.merchant.length,
    //                 campaignConfirmationModel: true,
    //                 promotion_id: promotion_id,
    //                 selectedFile1: null,
    //                 selectedFile2:null,
    //                 selectedFile3:null,
    //                 selectedFile4:null,
    //                 party_master_id: res.data.party_master_id
    //             });
    //             //console.log(res);
    //             this.setState({
    //                 isSubmit:false,
    //                 loading:false
    //             })
    //         })
    //         .catch(err => { // then print response status
    //             this.handleNotificationClick("tr", 3, "Something Wrong!");
    //             this.setState({
    //                 isSubmit:false,
    //                 loading:false
    //             })
    //         })
    // }

    // updatePartyType = (valuer) => {
    //     if (valuer.value == 'Merchant'){
    //         this.handleNotificationClick("tr", 3, "Merchant promotions is under construction.");
    //         // this.setState({
    //         //     selected_party_type: valuer.value,
    //         //     selected_party_type2: [{value: valuer.value, label: valuer.label}],
    //         //     uploadDropdown: false,
    //         //     upload_user_type: 2,
    //         //     loading: true,
    //         //     selected_party: null,
    //         //     selected_party2: null,
    //         //     party_list: [],
    //         //     party_master_id: 5,
    //         // }, () => {
    //         //     this.getPartyList();
    //         //     this._refreshCampaign();
    //         // });
    //     }
    //     else if( valuer.value == 'Brand'){
    //         this.setState({
    //             selected_party_type: valuer.value,
    //             selected_party_type2: [{value: valuer.value, label: valuer.label}],
    //             uploadDropdown: false,
    //             upload_user_type: 7,
    //             loading: true,
    //             selected_party: null,
    //             selected_party2: null,
    //             party_master_id: 5,
    //             party_list: []
    //         }, () => {
    //             this.getPartyList();
    //         });
    //     }
    // };

    // updatePartyValue = (valuer) => {
    //     this.setState({
    //         selected_party: valuer.value,
    //         selected_party2: [{value: valuer.value, label: valuer.label}],
    //         party_master_id: valuer.value,
    //         loading: false,
    //         uploadDropdown: false
    //     }, () => {
    //         this._refreshCampaign();
    //     });
    // };

    updatePartyType(optionSelected){
        this.setState({
            loading: true
        })
        var value='';
        var partyTypeArray = [];
        if(optionSelected.length<1){
            value = null;
            partyTypeArray = '';
        }
        else{
            optionSelected.map((partytypeids, i) => {
                partyTypeArray.push(partytypeids.value)
            });
        }
        this.setState({
            partyTypeID:partyTypeArray,
            partyTypeValue:optionSelected,
            uploadDropdown: false,
            // partyID: '',
            // partyValue: null,
            party_list: [],
            loading: false
        }, () =>{
            this.getPartyList();
            this._refreshCampaign();
        });
        
        // this.setState({
        //     selected_party_type: valuer.value,
        //     selected_party_type2: [{value: valuer.value, label: valuer.label}],
            
        //     upload_user_type: 7,
            
        //     selected_party: null,
        //     selected_party2: null,
        //     party_master_id: 5,
        //     party_list: []
        // }, () => {
        //     this.getPartyList();
        // });
        
    };

    gotopm = () =>{
        this.props.history.push('/admin/admin-promotion-master');
    }

    // sendApproveCampaign(){
    //     this.setState({
    //         upload_disabler: true
    //     });
    //     const timer1 = (Date.now()).toString();
    //     const data = new FormData();
    //     const token = localStorage.usertoken;
    //     const decoded = jwt_decode(token);
    //     var kill = 0;

    //     if(this.state.selectedFile1 == null){
    //         this.handleNotificationClick("tr", 3, "Please upload valid file");
    //         kill = 1;
    //     }

    //     if(this.state.innoviti_files == '1'){
    //         if(this.state.selectedFile2 == null){
    //             this.handleNotificationClick("tr", 3, "Please upload Innoviti files");
    //             kill = 1;
    //         }
    //         else{
    //             data.append('file2', this.state.selectedFile2);
    //             data.append('file2_stat', '1');
    //         }
    //     }
    //     else{
    //         data.append('file2', '');
    //         data.append('file2_stat', '');
    //     }

    //     var bank_counts = Number(this.state.bank_count);
    //     if(bank_counts > 0){
    //         if(this.state.selectedFile3 != null){
    //             var zlen = Object.keys(this.state.selectedFile3).length;
    //             if(Number(zlen) != bank_counts){
    //                 this.handleNotificationClick("tr", 3, "Please upload all bank files");
    //             }
    //             else{
    //                 for(var z = 0; z<zlen; z++) {
    //                     if(this.state.selectedFile3[z] == null){
    //                         this.handleNotificationClick("tr", 3, "Please upload all bank files");
    //                         kill = 1;
    //                         break;
    //                     }
    //                     data.append('file3', this.state.selectedFile3[z][0]);
    //                 }
    //                 data.append('file3_stat', '1');
    //             }
    //         }
    //         else{
    //             this.handleNotificationClick("tr", 3, "Please upload all bank files");
    //         }
    //     }  
    //     else{
    //             data.append('file3', '');
    //             data.append('file3_stat', '');
    //     }

    //     var merchant_counts = Number(this.state.merchant_count);

    //     if(merchant_counts > 0){
    //         if(this.state.selectedFile4 != null){
    //             var wlen = Object.keys(this.state.selectedFile4).length;
    //             if(Number(wlen) != merchant_counts){
    //                 this.handleNotificationClick("tr", 3, "Please upload all merchant files");
    //             }
    //             else{
    //                 for(var w = 0; w<wlen; w++) {
    //                     if(this.state.selectedFile4[w] == null){
    //                         this.handleNotificationClick("tr", 3, "Please upload all merchant files");
    //                         kill = 1;
    //                         break;
    //                     }
    //                     data.append('file4', this.state.selectedFile4[w][0]);
    //                 }
    //                 data.append('file4_stat', '1');
    //             }
    //         }
    //         else{
    //             this.handleNotificationClick("tr", 3, "Please upload all merchant files");
    //         }
    //     }
    //     else{
    //         data.append('file4', '');
    //         data.append('file4_stat', '');
    //     }
    //     if(kill == 0){
    //         data.append('scheme_id', this.state.promotion_id);
    //         data.append('timer1', timer1);
    //         data.append('party_master_id', this.state.party_master_id);
    //         data.append('userID', decoded._id);
    //         data.append('file1', this.state.selectedFile1);
    //         data.append('merchant_files', JSON.stringify(this.state.merchant_files));
    //         data.append('bank_files', JSON.stringify(this.state.bank_files));
    //         data.append('brand_files', this.state.brand_files);
    //         axios.post(config.get('API_URL') + '/brandemi/submit_campaign_approve_master', data, {
    //             headers: {
    //                 Authorization: ` ${localStorage.usertoken}`
    //             }
    //         }).then(res => {
    //             this.handleNotificationClick("tr", 1, "File upload successful");
    //             //console.log(res.data);
    //             this.props.history.push('/admin/brand-emi');
    //             //this.gotopm();
    //         }).catch(err => {
    //             this.handleNotificationClick("tr", 3, "Something wrong! Please retry after few moments");
    //         })
    //     }
    //     else{
    //         this.setState({
    //             upload_disabler: false
    //         });
    //     }
    // }

    updatePartyValue(optionSelected){
        //console.log(optionSelected);
        this.setState({
            loading: true
        })
        var value='';
        var partyArray = [];
        if(optionSelected.length<1){
            value = null;
            partyArray = '';
        }
        else{
            optionSelected.map((partyids, i) => {
                partyArray.push(partyids.value)
            });
        }
        this.setState({
            partyID:partyArray,
            partyValue:optionSelected,
            uploadDropdown: false,
            loading: false
        }, () => {
            this._refreshCampaign();
        });
        
        // this.setState({
        //     selected_party: valuer.value,
        //     selected_party2: [{value: valuer.value, label: valuer.label}],
        //     party_master_id: valuer.value,
        //     loading: false,
        //     uploadDropdown: false
        // }, () => {
        //     this.getBrandUploadedData();
        // });
    };

    getPartyList() {
        const token = localStorage.usertoken;
        axios.post(config.get('API_URL')+'/brandemi/get_party_list_filter', {
                party_type: this.state.partyTypeID
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => { //console.log(response);
            var party_list = [];
            this.setState({
                party_list: [],
                selected_party: null
            });
            response.data.data.map((values, index) => {
                if (values.party_name != 'Admin'){
                    party_list.push({value: values.id, label: values.party_name})
                }
            });
            this.setState({
                party_list: party_list,
                loading: false
            })
        });
    }

    mapData(id, map_status, stored_file_name, user_type, user_id, file_name){
        this.setState({
            id: id,
            map_status: map_status,
            stored_file_name: stored_file_name,
            userGroup: user_type,
            user_id: user_id,
            file_name: file_name
        });
        this.openSectionToMap(true);
    }

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    openSectionToMap = (status) => {
        //console.log(this.state.userGroup);
        this.setState({
            mapField: status
        })
    };

    updateMapVisiblity = (value) => {
        //console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };
    
    render() {
        console.log(this.state.campaign_response);
        // if(this.state.selectedFile4 != null){
        //     console.log(this.state.selectedFile4.length);
        //     console.log(this.state.selectedFile4[0]);
        //     console.log(this.state.selectedFile4[0][0]);
        // }
        const MenuList = props => {
            const rows = props.children;
            var no_of_rows = 0;
            var drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };


        var party_render = this.state.party_options;
        var party_render_list = this.state.party_list;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);

        // var brand_upload_displayer = () => {
        //     return(
        //             <div className="row">
        //                 <div className="col-md-12">
        //                     <div className="form-group form-bottom">
        //                         <label htmlFor="queryName1" className="pull-centere">Upload File for {this.state.brand_files}</label>
        //                         <input type="file" name="brand_file" className="form-control pull-centere" onChange={this.onChangeHandler1} />
        //                     </div>
        //                 </div>
        //             </div>
        //             )
        // }

        // var innoviti_upload_displayer = () => {
        //     if(this.state.innoviti_files == 1 || this.state.innoviti_files == '1'){
        //         return(
        //             <div className="row">
        //                 <div className="col-md-12">
        //                     <div className="form-group form-bottom">
        //                         <label htmlFor="queryName1" className="pull-centere">Upload File for Innoviti</label>
        //                         <input type="file" name="innoviti_file" className="form-control pull-centere" onChange={this.onChangeHandler2} />
        //                     </div>
        //                 </div>
        //             </div>
        //         )
        //     }
        // }

        // var bank_upload_displayer = this.state.bank_files.map((values, index) => {
        //         return(
        //             <div key={index} className="row">
        //                 <div className="col-md-12">
        //                     <div className="form-group form-bottom">
        //                         <label htmlFor="queryName1" className="pull-centere">Upload File for {values}</label>
        //                         <input key={index} type="file" name={"bank_" + values} className="form-control pull-centere" onChange={this.onChangeHandler3.bind(this, index)} />
        //                     </div>
        //                 </div>
        //             </div>
        //         )
        //     })

        // var merchant_upload_displayer = this.state.merchant_files.map((values, index) => {
        //     return(
        //         <div key={index+"_"} className="row">
        //             <div className="col-md-12">
        //                 <div className="form-group form-bottom">
        //                     <label htmlFor="queryName1" className="pull-centere">Upload File for {values}</label>
        //                     <input key={index} type="file" name={"merchant_" + values} className="form-control pull-centere" onChange={this.onChangeHandler4.bind(this,index)} />
        //                 </div>
        //             </div>
        //         </div>
        //     )
        // }); 

        var party_shower = () => {
            if(decoded.userGroup == 1 || decoded.userGroup == '1'){
                return(
                    <div className="row top-margin-30">
                        <div className="col-md-3">
                            <Label>Select party type</Label>
                            <ReactMultiSelectCheckboxes name={"party_type_filter"}
                                components={{ MenuList }}
                                value={this.state.partyTypeValue}
                                styles={customStyles} className="report-listbox"
                                onChange={this.updatePartyType.bind(this)}
                                options={party_render}
                                placeholderButtonLabel="Select [Party Type]"
                                // isClearable={true}
                                
                            />
                        </div>  
                        <div className="col-md-3">
                            <Label>Select party</Label>
                            <ReactMultiSelectCheckboxes name={"party_name_filter"}
                                components={{ MenuList }}
                                value={this.state.partyValue}
                                styles={customStyles} className="report-listbox"
                                onChange={this.updatePartyValue.bind(this)}
                                options={party_render_list}
                                placeholderButtonLabel="Select [Party Name]"
                                // isClearable={true}
                            />
                        </div> 
                    </div>
                )
            }
            else{
                return(
                    <div></div>
                )
            }
        };

        var campaign_data = this.state.campaign_response.map((value,index) => {
            var Activer = 'Created';
            var edit_activer = false;
            var timer = new Date(value.start_date).toJSON().slice(0, 10).replace('T', ' ');
            var timer1 = new Date(value.end_date).toJSON().slice(0, 10).replace('T', ' ');
            timer = moment(timer).format('YYYY-MM-DD');
            timer1 = moment(timer1).format('YYYY-MM-DD');
            var timer2 = new Date(value.record_update_timestamp);
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            // timer
            var timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            if (value.active != 0 || value.active != '0')
            {
                if (value.active == -1 || value.active == '-1'){
                    Activer = 'Rejected';
                    edit_activer=true;
                }
                else if (value.active == 2 || value.active == '2'){
                    Activer = 'Configured';
                    edit_activer=true;
                }
                else if (value.active == 3 || value.active == '3'){
                    Activer = 'QA Verified';
                    edit_activer=true;
                }
                else if ((value.active == 4 || value.active == '4') && (value.flag == '1' || value.flag == 1)){
                    Activer = 'Automated';
                    edit_activer=true;
                }
                else if ((value.active == 4 || value.active == '4') && (value.flag == '-1' || value.flag == -1)){
                    Activer = 'API Failure';
                    edit_activer=true;
                }
                else if ((value.active == 4 || value.active == '4') && (value.flag == '-2' || value.flag == -2)){
                    Activer = 'Timed Out';
                    edit_activer=true;
                }
                else if (value.active == 4 || value.active == '4'){
                    Activer = 'Ready';
                    edit_activer=true;
                }
                else if (value.active == 1 || value.active == '1'){
                    Activer = 'Approved';
                    edit_activer=true;
                }
                else{
                    Activer = 'Expired';
                    edit_activer=true;
                }

                return (
                    <tr key={index + 1}>
                        <td>{value.party_type}</td>
                        <td>{value.party_name}</td>
                        <td>{value.campaign_name}</td>
                        <td>{value.campaign_desc}</td>
                        <td>{timer}</td>
                        <td>{timer1}</td>
                        <td>{timer3}</td>
                        <td>{Activer}</td>
                        <td>
                            <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                            <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/admin-view-promotion1/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                        </td>
                    </tr>
                );
            }
            else{

                return (
                    <tr key={index + 1}>
                        <td>{value.party_type}</td>
                        <td>{value.party_name}</td>
                        <td>{value.campaign_name}</td>
                        <td>{value.campaign_desc}</td>
                        <td>{timer}</td>
                        <td>{timer1}</td>
                        <td>{timer3}</td>
                        <td>{Activer}</td>
                        <td>
                            <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                            <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/admin-view-promotion1/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                            <Link className="viewButton" disabled={edit_activer} data-tip="Edit Promotion"  to={"/admin/admin-edit-promotion/" + value.id}><span className="glyphicon glyphicon-edit" aria-hidden="true"></span></Link>
                            {/* <Link className="viewButton" disabled={edit_activer} data-tip="Upload Files"  onClick={this.uploadFilesData.bind(this, value.id)}><span className="glyphicon glyphicon-upload" aria-hidden="true"></span></Link> */}
                        </td>
                    </tr>
                );
            }
        });

        return(
            <div className="longcontent">
                <CommonNavbar/>
            <div className="container-fluid">


            <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                {/* <Modal className="modalsmall" isOpen={this.state.campaignConfirmationModel} 
                toggle={this.toggleCampaignModel.bind(this)} 
                size = "sm"
                >
                    <ModalBody>
                        <div className="row">
                            <div className="col-xs-12 ">
                                <h4 className="modalh4"> Are you sure you want to approve?</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                Valid files are: .doc, .docx, .csv, .jpg, .jpeg, .png, .xls, .xlsx, .pdf, .eml, .zip and .txt 
                            </div>
                        </div>
                        <hr/>
                        <div className="row">
                            
                        </div>
                        {brand_upload_displayer()}
                        {bank_upload_displayer}
                        {merchant_upload_displayer}
                        {innoviti_upload_displayer()} 
                        <ModalFooter>
                            <Button color="primary" disabled={this.state.upload_disabler} className="btn btn-primary btn-capitalize" onClick={this.sendApproveCampaign.bind(this)}>Upload Files</Button>{' '}
                            <Button color="secondary" disabled={this.state.upload_disabler} className="btn btn-primary btn-capitalize2" onClick={this.toggleCampaignModel.bind(this)}>Cancel</Button>
                        </ModalFooter>
                    </ModalBody>
                </Modal> */}
                <div className="pt-5">
                    <div className="card " ref={this.myRef}>
                        
                            <div className="header">
                                
                                    <h4 className="title pull-left">Promotions</h4>
                                    <button onClick={this.campaignDropdown} className="btn btn-primary btn-capitalize pull-right">Create New</button>
                                
                            </div>
                        
                        <div className="content">
                            <div className='sweet-loading'>
                                <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                />
                            </div>
                            {/* <div className="col-md-12">
                                
                            </div> */}
                            {party_shower()}
                            <div className="row">
                                <div className="content table-full-width table-responsive">
                                    <table className="table table-striped table-hover" id="campaignTable">
                                        <thead>
                                        <tr>
                                            <th>Party Type</th>
                                            <th>Party Name</th>
                                            <th>Promotion Name</th>
                                            <th>Promotion Description</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Update Timestamp</th>
                                            <th>Status</th>
                                            <th width="60px">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {campaign_data}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="footer">
                                <div className="stats"><i></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        );
    }
}


export default AdminPromotionMaster;